import React, { Component } from 'react'
import { func, string, object } from 'prop-types'
import { CancellationModal } from '../../modals/CancellationModal'
import { translate } from 'react-i18next'

class CancellationButtonComponent extends Component {
  constructor () {
    super()
    this.state = { open: false }
  }

  closeModal () {
    this.setState({ open: false })
  }

  openModal () {
    this.setState({ open: true })
  }

  render () {
    const { t, id, style } = this.props
    return (
      <div>
        <button onClick={() => this.openModal()} className='btn--green' style={style}>{t('common:buttons:cancel')}*</button>
        <CancellationModal isOpen={this.state.open} handleClose={() => this.closeModal()} id={id} onCancel={this.props.onCancel}/>
      </div>
    )
  }
}

CancellationButtonComponent.propTypes = {
  t: func,
  id: string,
  style: object,
  onCancel: func
}

export const CancellationButton = translate()(CancellationButtonComponent)



// WEBPACK FOOTER //
// ./src/components/ui/buttons/CancellationButton.js